import { includes } from "lodash";

import { TAGS_UI_COMPONENTS } from "src/consts/tags";

export type TagNavigabilityInput = {
  type?: string | null;
  tagTypeConfig?: { visibleIn?: string[] | null } | null | undefined;
};

/**
 * Tag chips should only navigate (tag or person page) when the type is
 * configured to show in TeamForm. Missing visibleIn keeps legacy clickability
 * for un-enriched tags (fail-open). `isTagVisible` is the opposite: no
 * visibleIn means not visible (fail-closed).
 */
export const isTagNavigableInTeamform = (
  tag?: TagNavigabilityInput | null
): boolean => {
  if (!tag) {
    return false;
  }

  const visibleIn = tag.tagTypeConfig?.visibleIn;

  if (visibleIn == null) {
    return true;
  }

  return includes(visibleIn, TAGS_UI_COMPONENTS.TEAMFORM);
};
